module.exports = __webpack_public_path__ + "img/winner.20e4a6f5.svg";